import script from "./AlertModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./AlertModal.vue?vue&type=script&setup=true&lang=ts"

import "./AlertModal.vue?vue&type=style&index=0&id=35e4fd67&scope=true&lang=css"

const __exports__ = script;

export default __exports__